export { default } from './MilitaryRankStar'
